/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { LocationInstance } from "../models/location-instance";
import { ZoneInstance } from "../models/zone-instance";
import { LocationService } from "../services/location.service";
import { ZoneService } from "../services/zone.service";

import { Input, Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class LocationZoneInstancesResolver implements Resolve<LocationInstance[]> {

    constructor(
        private locationService: LocationService,
        private zoneService: ZoneService
    ) {}

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<LocationInstance[]> {
        try {
            const locations: LocationInstance[] = await this.locationService.getAllLocationInstances();
            
            for (let location of locations) {
                const zones: ZoneInstance[] = await this.zoneService.getZonesByLocationId(location.id);
                location.zones = zones;
            }
            
            return locations;
        }
        catch (error) {
            console.error("Problem resolving Location/Zone instances... Error: " + error, error);
        }
    }

}
